// extracted by mini-css-extract-plugin
module.exports = {"FormBody":"NewCorporateAction_FormBody__i_yoB","RequiredFields":"NewCorporateAction_RequiredFields__16UMO","OptionalFields":"NewCorporateAction_OptionalFields__2Rhay"};